import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { snackbarUtils } from "../../utils";
import { useUpdateUserRole } from "../../hooks/useUsers";

export default function EditUserRoleDialog(props) {
  const { open, handleClose, user } = props;
  const [role, setRole] = useState("user");

  const updateRoleMutation = useUpdateUserRole();

  useEffect(() => {
    if (open && user) {
      setRole(user.role === "admin" ? "admin" : "user");
    }
  }, [open, user]);

  const handleSave = () => {
    if (!user?.id) return;

    updateRoleMutation.mutate(
      { id: user.id, role },
      {
        onSuccess: () => {
          snackbarUtils.updateMessage("Role updated");
          handleClose();
        },
        onError: () => {
          snackbarUtils.updateMessage("Failed to update role");
        },
      }
    );
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Edit User Role</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 1 }}>
          <RadioGroup
            value={role}
            onChange={(e) => setRole(e.target.value)}
            name="role"
          >
            <FormControlLabel value="user" control={<Radio />} label="User" />
            <FormControlLabel
              value="admin"
              control={<Radio />}
              label="Super Admin"
            />
          </RadioGroup>
        </FormControl>
        {role === "admin" && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            Super Admin gives this user access to the management environment
            and full access to all resources in the main app. Only grant this
            role to trusted users.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="info" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          onClick={handleSave}
          disabled={updateRoleMutation.isPending}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
